import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { takeUntil } from 'rxjs/operators';
import { SweetAlertOptions } from 'sweetalert2';
import {
  ApiURL, CLUSTER_ARRAY, CLUSTER_PERMISSION_PROPERTY, EMAIL_SUGGESTIONS, LOGGED_IN_PROPERTY,
  SINGLE_CLUSTER_PROPERTY, SUPER_ADMIN, USER_INFO
} from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';


@Injectable()
export class NGaugeService {

  meldURL: any='https://v1.hubtricity.com/api/';
  adminUsers = [];
  reportAdminUsers = [];
  clusterUsers = [];
  functionRooms = [];
  usersWithoutProperty = [];
  reqPrintValSub = new BehaviorSubject<any>(null);
  reqPrintValue = this.reqPrintValSub.asObservable();
  onDestroy = new Subject<void>();
  SID = null;

  constructor(
    private httpClient: HttpClient,
    private toastr: ToastrService,
    private router: Router) {
    }



  getMeldURL(urlValue) {
    return "https://v1.hubtricity.com/api/" + ApiURL[urlValue];
  }

  requestPrintData(value) {
    this.reqPrintValSub.next(value);
  }

  isJSON(value) {
    try { return JSON.parse(value); } catch (e) {
      return value;
    }
  }

  _keyPress(event: any) {
    const pattern = /[a-zA-Z ~`!@#$%^&()_={}[\]:;,."'<>+\?*-]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Without decimal
  blockAlpha(event: any) {
    const pattern = /[a-zA-Z ~`!@#$%^&()_={}[\]:;,"'<>+\?*-]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  blockNumerics(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  swalOKButton(swalObject): SweetAlertOptions {
    return {
      title: swalObject['title'],
      text: swalObject['text'],
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonColor: '#3085d6'
    };
  }

  swalCancelButton(swalObject): SweetAlertOptions {
    return {
      title: swalObject['title'],
      text: swalObject['text'],
      type: 'warning',
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonColor: '#d33'
    };
  }

  swalOkCancelButton(swalObject): SweetAlertOptions {
    return {
      title: swalObject.title,
      text: swalObject.text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: swalObject.confirmButtonText,
      cancelButtonText: swalObject.cancelButtonText
    };
  }

  getRandomColor() {
    const colors: any = {
      red: 'rgb(255,84,84)',
      purple: '#833AB4',
      green: 'rgb(61,204,91)',
      dark_blue: '#009688',
      orange: '#f4c20d'
    };
    return colors;
  }

  getRandomNumber() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  sortArray(data) {
    data.sort((a, b) => {
      return (a < b ? -1 : (a < b ? 1 : 0));
    });
    if (data.find(value => value === 'All')) {
      data = this.checkForAll(data, data.findIndex(value => value === 'All'));
    }
    return data;
  }

  sortByContent(data, field) {
    data.sort((a, b) => (a[field] < b[field]) ? -1 : ((a[field] > b[field]) ? 1 : 0));
    if (data.find(value => value[field] === 'All')) {
      data = this.checkForAll(data, data.findIndex(value => value[field] === 'All'));
    }
    return data;
  }

  checkForAll(data, findIndex) {
    const allValue = data[findIndex];
    if (findIndex > 0) {
      for (let i = findIndex; i >= 1; i--) {
        data[i] = data[i - 1];
      }
      data[0] = allValue;
    }
    return data;
  }

  appendFNameAndLName(users, SID = null) {
    users.forEach((user) => {
      user['userName'] = user['firstName'] + ' ' + user['lastName'];
    });

    if (SID) {
      const contacts = users.filter(user => user['SID'] == SID);
      return contacts;
    }

    return users;
  }

  // Sorting array of Objects
  // array => Array to sort
  // value => object key to sort in array
  removeArrayDuplicates(array, value) {
    return Object.values(array.reduce((r, o) => {
      r[o[value]] = r[o[value]] || { ...o };
      return r;
    }, {}));
  }

  removeDuplicatesArrOfString(arrayDetails) {
    const uniqueData = [];
    arrayDetails.forEach((data) => {
      if (uniqueData.indexOf(data) === -1 && data !== '') {
        uniqueData.push(data);
      }
    });
    return uniqueData;
  }

  // finding date between  start & end date
  checkDateBetween2Days(fromDate, toDate, dateToCheck) {
    fromDate = DateUtil.getNewDate(DateUtil.getValidTimeZone(fromDate));
    toDate = DateUtil.getNewDate(DateUtil.getValidTimeZone(toDate));
    dateToCheck = DateUtil.getNewDate(DateUtil.getValidTimeZone(dateToCheck));
    let result = false;
    if ((dateToCheck >= fromDate && dateToCheck <= toDate) || dateToCheck === fromDate || dateToCheck === toDate) {
      result = true;
    }
    return result;
  }

  // for Group testing
  findCountBetweenDates(fromDate: Date, toDate: Date) {
    fromDate = DateUtil.getDayStart(fromDate);
    toDate = DateUtil.getDayEnd(toDate);
    return ((toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24));
  }

  // Http Params for AWS Link integration
  getHttpParams(filter) {
    const httpParams = new HttpParams();
    return httpParams.append('filter', filter);
  }

  toastrSuccess(message) {
    this.toastr.success(message, 'Success');
  }

  toastrInfo(message) {
    this.toastr.info(message);
  }

  toastrError(message) {
    this.toastr.error(message, 'Failure');
  }

  toastrWarning(message) {
    this.toastr.warning(message, 'Failure');
  }

  getGroupBy(dataList, key): any {
    return new Promise((resolve) => {
      const myArray1 = dataList.reduce((previous, current) => {
        if (!previous[current[key]]) {
          previous[current[key]] = [current];
        } else {
          previous[current[key]].push(current);
        }
        return previous;
      }, {});
      const result = Object.keys(myArray1).map(keyVal => ({ key: keyVal, value: myArray1[keyVal] }));
      resolve(result);
    });
  }

  sendSignRequest(base64, mails, pdfName) {
    const params = {
      'email': JSON.stringify(mails),
      'doc': { docinfo: JSON.stringify(base64) },
      'pdfName': pdfName
    };
    return this.httpClient.post(this.getMeldURL('SEND_SIGN_REQUEST'), params);
  }

  sortByDate(list, field) {
    list.sort((a, b) => DateUtil.getNewDate(a[field]).getTime() - DateUtil.getNewDate(b[field]).getTime()); // Ascending sort
    return list;
  }

  getPropertyTypesList(): any {
    const userDetails = this.isJSON(sessionStorage.getItem(USER_INFO));
    const userType = userDetails['userType'];
    const userProperty = [];
    const clusterProperty = this.getIsClusterProperty();
    if (clusterProperty) {
      const singleCluster = this.isJSON(sessionStorage.getItem(SINGLE_CLUSTER_PROPERTY));
      if (singleCluster) {
        const loggedInProperty = sessionStorage.getItem(LOGGED_IN_PROPERTY);
        return of([{ name: loggedInProperty }]);
      }
      const clusterProperties = this.isJSON(sessionStorage.getItem(CLUSTER_PERMISSION_PROPERTY));
      clusterProperties.forEach(property => {
        const temp = { name: property };
        userProperty.push(temp);
      });
      return of(userProperty);
    } else {
      if (userType !== SUPER_ADMIN) {
        userProperty.push({ name: userDetails['property'] });
        return of(userProperty);
      } else {
        const columnFilter = '"fields": ["name", "id", "SID"]';
        const filter = '{' + columnFilter + '}';
        const params = { params: this.getHttpParams(filter) };
        return this.httpClient.get(this.getMeldURL('GET_PROPERTY_LIST'), params);
      }
    }
  }

  openOutlookMail(mailId) {
    const mailToLink = 'mailto:' + mailId;
    window.location.href = mailToLink;
  }

  openOutlook(mailBody) {
    const mailToLink = 'mailto:?subject=&body=' + encodeURI(mailBody);
    window.location.href = mailToLink;
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent;
    if (/msie\s|trident\//i.test(agent) || agent.indexOf('OPR') !== -1) {
      return false;
    } else if (agent.indexOf('Chrome') !== -1 || agent.indexOf('Firefox') !== -1) {
      return true;
    } else {
      return false;
    }
  }

  getOperatingSystem() {
    if (navigator.appVersion.indexOf('Win') !== -1) {
      return 'Windows OS';
    } else if (navigator.appVersion.indexOf('Mac') !== -1) {
      return 'MacOS';
    } else if (navigator.appVersion.indexOf('X11') !== -1) {
      return 'UNIX OS';
    } else if (navigator.appVersion.indexOf('Linux') !== -1) {
      return 'Linux OS';
    }
  }

  getClipboardContent() {
    return window.navigator['clipboard'].readText();
  }

  checkForValidity(value) {
    return (value !== null && value !== undefined && value !== '') ? true : false;
  }

  checkForNllUndef(value) {
    return (value !== null && value !== undefined) ? true : false;
  }

  checkForNllEmpty(value) {
    return (value !== null && value !== '') ? true : false;
  }

  stringToHTML(str) {
    const dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
  }

  buildFilter(formControl: FormControl, filteredDropDownValue: ReplaySubject<any[]>, arrayData: any[], field: any) {
    arrayData = field === '' ? this.sortArray(arrayData) : this.sortByContent(arrayData, field);
    filteredDropDownValue.next(arrayData.slice());
    formControl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.filterArrayValues(formControl, filteredDropDownValue, arrayData, field);
      });
  }


  buildNonSortFilter(formControl: FormControl, filteredDropDownValue: ReplaySubject<any[]>, arrayData: any[], field: any) {
    filteredDropDownValue.next(arrayData.slice());
    formControl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.filterArrayValues(formControl, filteredDropDownValue, arrayData, field);
      });
  }

  filterArrayValues(formControl, filteredDropDown, array, field) {
    if (!array) { return; }
    let search = formControl.value;
    if (!search) {
      filteredDropDown.next(array.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filteredDropDown.next(
      array.filter(data => field !== '' ?
        (data[field].toLowerCase().indexOf(search) > -1) :
        (data.toLowerCase().indexOf(search) > -1)));
  }

  getContactAddress(contactDetails) {
    const address = this.checkForValidity(contactDetails.address) ? contactDetails.address + ',\n' : '';
    const city = this.checkForValidity(contactDetails.city) ? contactDetails.city + ',' : '';
    const state = this.checkForValidity(contactDetails.state) ? contactDetails.state +
      (this.checkForValidity(contactDetails.zip) ? ' - ' + contactDetails.zip + '.' : '') : '';
    return address + city + state;
  }

  getIsClusterProperty() {
    const currentProperty = this.isJSON(sessionStorage.getItem(LOGGED_IN_PROPERTY));
    const clusterArray = this.isJSON(sessionStorage.getItem(CLUSTER_ARRAY));
    const singleCluster = this.isJSON(sessionStorage.getItem(SINGLE_CLUSTER_PROPERTY));
    if (singleCluster) { return true; }
    if (clusterArray !== null) {
      if (clusterArray.find(item => item.permissionProperty.find((property: String) => property === currentProperty))) {
        return true;
      }
    }
    return false;
  }

  checkForMultiCluster(): boolean {
    const currentProperty = this.isJSON(sessionStorage.getItem(LOGGED_IN_PROPERTY));
    const clusterArray = this.isJSON(sessionStorage.getItem(CLUSTER_ARRAY));
    let result = false;
    if (clusterArray !== null) {
      ClusterLoop: for (let i = 0; i < clusterArray.length; i++) {
        for (let j = 0; j < clusterArray[i].permissionProperty.length; j++) {
          if (clusterArray[i].permissionProperty[j] === currentProperty &&
            clusterArray[i].permissionProperty.length > 1) {
            result = true;
            break ClusterLoop;
          }
        }
      }
    }
    return result;
  }

  accountAccessible(type, property, loggedInProperty) {
    const isClusterProperty = this.getIsClusterProperty();
    return !isClusterProperty ? true :
      (type === 'Multiple Property' ? true : (property === loggedInProperty ? true : false));
  }

  getCurrentUrl() {
    return this.router.url;
  }

  routeTo(url: string) {
    this.router.navigateByUrl(url);
  }

  routeWithParams(url: string, params: {}, skipLocationChange: boolean) {
    this.router.navigate([url], { queryParams: params, skipLocationChange });
  }

  getInvalidUser(userName) {
    return {
      firstName: 'Invalid',
      lastName: 'User',
      id: 0, userName
    };
  }

  getTemplate(templateName) {
    let params = new HttpParams();
    params = params.append('templateName', templateName);
    return this.httpClient.get(this.getMeldURL('GET_TEMPLATE'), { params: params });
  }

  downloadPDF(pdf, fileName) {
    const downloadLink = document.createElement('a');
    const newFileName = fileName + '.pdf';
    downloadLink.href = pdf;
    downloadLink.download = newFileName;
    downloadLink.click();
  }

  sendSignUrl(values) {
    if (values['id'] === 0) {
      return this.httpClient.post(this.getMeldURL('CONTRACT_SIGN'), values);
    } else {
      return this.httpClient.put(this.getMeldURL('CONTRACT_SIGN') + '/' + values['id'], values);
    }
  }

  getSignUrls(value) {
    const whereCondition = '"where": {"and":[{"type":"' + value['type'] + '"},{"documentId":"' + value['documentId'] + '"}]}';
    const filter = '{' + whereCondition + '}';
    const params = { params: this.getHttpParams(filter) };
    return this.httpClient.get(this.getMeldURL('CONTRACT_SIGN'), params);
  }

  checkForMobile(mNumber) {
    return mNumber === '' || mNumber === null || mNumber.includes('X') ? true : false;
  }

  checkForMail(mailId) {
    return mailId === '' || mailId === null || EMAIL_SUGGESTIONS.includes(mailId) ? true : false;
  }

  populateReportData(reportData, title) {
    return new Promise(resolve => {
      const data = [];
      let widths = ['11%', '13%', '13%', '12%', '13%', '12%', '12%', '14%'];
      data[0] = [
        { text: 'Assign Date', style: 'tableHeader' },
        { text: 'Type', style: 'tableHeader' },
        { text: 'Account', style: 'tableHeader' },
        { text: 'Contact', style: 'tableHeader' },
        { text: 'Title', style: 'tableHeader' },
        { text: 'Phone Number', style: 'tableHeader' },
        { text: 'Sales Person', style: 'tableHeader' },
        { text: 'Objective', style: 'tableHeader' }
      ];
      if (title === 'Completed Sales Activity') {
        data[0] = [
          { text: 'Assign Date', style: 'tableHeader' },
          { text: 'Type', style: 'tableHeader' },
          { text: 'Account', style: 'tableHeader' },
          { text: 'Objective', style: 'tableHeader' }
        ];
        data[0].push({ text: 'Result', style: 'tableHeader' });
        widths = ['20%', '20%', '20%', '20%', '20%'];
      }
      for (let i = 0; i < reportData.length; i++) {
        const salesActivity = reportData[i];
        const contact = salesActivity.account.contact[0];
        const userName = `${contact.firstName} ${contact.lastName}`;
        data[i + 1] = [
          { text: DateUtil.getMomentDate(DateUtil.getNewDate(salesActivity.startDate)), style: 'detail' },
          { text: salesActivity.salesActivityType, style: 'detail' },
          { text: salesActivity.account.account, style: 'detail' },
          { text: userName, style: 'detail' },
          { text: contact.designation, style: 'detail' },
          { text: salesActivity.contactDetail, style: 'detail' },
          { text: salesActivity.assigned, style: 'detail' },
          { text: salesActivity.objective, style: 'detail', alignment: 'justify' },
        ];
        if (title === 'Completed Sales Activity') {
          data[i + 1] = [
            { text: DateUtil.getMomentDate(DateUtil.getNewDate(salesActivity.startDate)), style: 'detail' },
            { text: salesActivity.salesActivityType, style: 'detail' },
            { text: salesActivity.account.account, style: 'detail' },
            { text: salesActivity.objective, style: 'detail', alignment: 'justify' },
          ];

          data[i + 1].push({ text: salesActivity.result, style: 'detail' });
        }
      }
      resolve({ data, widths });
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/ngauge.service.ts